// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer .nc-component[data-v-12e1f676]{width:100%}.outer .nc-component[data-v-12e1f676] .vs__dropdown-toggle{padding-block:0 !important;padding-inline:0 !important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
